export default "__VITE_ASSET__TgWtgaVN__"